import React from 'react';
import {
  FDTitleText, FDStack,
} from '@facet-wealth/design';
import { MessageInput } from 'Components/ComponentLibrary/Components/Uncategorized/MessageInput';
import { DataValueMap } from 'Helpers/Testing';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import ScenarioSelectionFAQ
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker/Content/ScenarioSelectionFAQ';

const ScenarioQuestionContent = ({
  scenarioQuestionResource,
  isMessageSending,
  draftMessageResource,
  handleContentChange,
  handleSendMessage,
}) => {
  return (
    <FDStack direction={'column'} spacing={4} paddingY={1}>
      <FDStack direction={'column'} spacing={2}>
        <FDTitleText value={scenarioQuestionResource.attr('title')} color={'textPrimary'} />
        <MessageInput
          placeholder={'Send a message'}
          messageSending={isMessageSending}
          messageResource={draftMessageResource}
          value={draftMessageResource?.attr('content')}
          onChange={handleContentChange}
          onSubmit={handleSendMessage}
          dataTestAttributes={DataValueMap.init('scenario-question-message-input').build()}
          rounded
          inputMinHeight={100}
          showAttachmentsInToolbar={false}
        />
      </FDStack>
      <ScenarioSelectionFAQ faqResource={scenarioQuestionResource.attr('faq').resources().head()} />
    </FDStack>
  );
};

ScenarioQuestionContent.defaultProps = {
};

ScenarioQuestionContent.propTypes = {
  scenarioQuestionResource: PropTypes.instanceOf(fr.Resource).isRequired,
  isMessageSending: PropTypes.bool.isRequired,
  draftMessageResource: PropTypes.instanceOf(fr.Resource).isRequired,
  handleContentChange: PropTypes.func.isRequired,
  handleSendMessage: PropTypes.func.isRequired,
};

export default ScenarioQuestionContent;
